/** Formatação de visualizações no padrão brasileiro. */

export function formatViewCount(views: number): string {
  const n = Math.max(0, Math.floor(Number.isFinite(views) ? views : 0));

  if (n < 1_000) {
    return new Intl.NumberFormat('pt-BR').format(n);
  }

  if (n < 1_000_000) {
    return new Intl.NumberFormat('pt-BR').format(n);
  }

  const millions = n / 1_000_000;
  if (millions < 10) {
    const rounded = Math.round(millions * 10) / 10;
    return `${rounded.toLocaleString('pt-BR', {
      minimumFractionDigits: rounded % 1 === 0 ? 0 : 1,
      maximumFractionDigits: 1,
    })} mi`;
  }

  return `${Math.round(millions).toLocaleString('pt-BR')} mi`;
}
